if (window.location.pathname.startsWith("/admin")) {
  import("./admin/mount");
}
